(() => {
  const closeSearch = (header, returnFocus = false) => {
    if (!header) return;

    const toggle = header.querySelector('[data-tl-search-toggle]');
    const panel = header.querySelector('[data-tl-search-panel]');
    if (!toggle || !panel) return;

    header.classList.remove('tl-search-open');
    toggle.setAttribute('aria-expanded', 'false');
    panel.setAttribute('aria-hidden', 'true');

    if (returnFocus) toggle.focus();
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-tl-search-toggle]');

    if (toggle) {
      const header = toggle.closest('.header');
      const panel = header ? header.querySelector('[data-tl-search-panel]') : null;
      if (!header || !panel) return;

      const willOpen = !header.classList.contains('tl-search-open');
      header.classList.toggle('tl-search-open', willOpen);
      toggle.setAttribute('aria-expanded', String(willOpen));
      panel.setAttribute('aria-hidden', String(!willOpen));

      if (willOpen) {
        window.setTimeout(() => {
          const input = panel.querySelector('input[type="search"]');
          if (input) input.focus();
        }, 180);
      }
      return;
    }

    document.querySelectorAll('.header.tl-search-open').forEach((header) => {
      if (!header.contains(event.target)) closeSearch(header);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const header = document.querySelector('.header.tl-search-open');
    if (header) closeSearch(header, true);
  });
})();
